import { render, staticRenderFns } from "./AssociationFiles.vue?vue&type=template&id=0b82bdfe&scoped=true"
import script from "./AssociationFiles.vue?vue&type=script&lang=js"
export * from "./AssociationFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82bdfe",
  null
  
)

export default component.exports